import * as Api from '../api/src'
interface GlobalData {
    Configurations: Api.SystemConfig | null,
}
let globalData: GlobalData = {
    Configurations: null,
}
export default globalData;